import React from 'react'
import clsx from 'clsx'
import { ClickAwayListener, Popper } from '@mui/material'

import useStyles from './styles'

const DropdownButton = ({
  options = [],
  renderOption = val => val,
  onSelect,
  children,
  disabled,
  autoWidth
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [width, setWidth] = React.useState(null)
  const open = Boolean(anchorEl)

  const classes = useStyles({ width, autoWidth })

  const handleClick = React.useCallback(
    e => {
      if (options.length === 1) {
        onSelect(options[0])
      } else {
        const anchor = anchorEl
        setAnchorEl(anchor ? null : e.currentTarget)
        setWidth(anchor ? null : `${e.currentTarget.clientWidth}px`)
      }
    },
    [options, onSelect, anchorEl]
  )

  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleSelect = React.useCallback(
    val => {
      onSelect(val)
      handleClose()
    },
    [onSelect, handleClose]
  )

  return options.length === 0 ? (
    children
  ) : (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <div
          onClick={disabled ? () => null : handleClick}
          className={clsx(classes.children, { [classes.disabled]: disabled })}
        >
          {children}
        </div>

        <Popper open={open} anchorEl={anchorEl} style={{ zIndex: '1500' }}>
          <div className={classes.options}>
            {options.map((opt, i) => (
              <div
                key={i}
                onClick={() => handleSelect(opt)}
                className={classes.option}
              >
                {renderOption(opt)}
              </div>
            ))}
          </div>
        </Popper>
      </div>
    </ClickAwayListener>
  )
}

export default DropdownButton
